import { render, staticRenderFns } from "./ContenidoTab.vue?vue&type=template&id=da77ddd2&"
import script from "./ContenidoTab.vue?vue&type=script&lang=js&"
export * from "./ContenidoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports